import { render, staticRenderFns } from "./EventServiceName.vue?vue&type=template&id=ae097374&scoped=true&"
import script from "./EventServiceName.vue?vue&type=script&lang=ts&"
export * from "./EventServiceName.vue?vue&type=script&lang=ts&"
import style0 from "./EventServiceName.vue?vue&type=style&index=0&id=ae097374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae097374",
  null
  
)

export default component.exports